import * as React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { ReactComponent as CalendarIcon } from '../assets/svg/calendar.svg';

interface DateInputTypes {
	dateTimeString: string;
	onChange?: any;
	showDropdowns?: boolean;
	excludeFuture?: boolean;
	excludePast?: boolean;
	disabled?: boolean;
	className?: string;
	minAge?: boolean;
}

export const DateInput: React.FC<DateInputTypes> = ({
	dateTimeString,
	onChange,
	showDropdowns = false,
	excludeFuture = false,
	excludePast = false,
	disabled = false,
	minAge = false,
	className
}) => {
	const [dateTimeObject, setDateTimeObject] = React.useState<Date>();

	//Set min age
	const minimunAge = 13;
	const maxDate = moment().subtract(minimunAge, 'years').format();

	// date comes in as a string: 2022-04-22T11:28:07.1994149+10:00
	// date is returned as a date object
	const parseDate = (str: string) => {
		const parsedDate = moment(str, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ');
		const newDate = parsedDate.isValid() ? parsedDate.toDate() : new Date();

		return newDate;
	};

	// date is returned as a string: 2022-04-22T11:28:07
	const returnDateTime = (obj: Date) => {
		// do not return the timezone offset
		const dateStr = moment(obj).format('YYYY-MM-DDTHH:mm:ss');

		if (onChange) {
			onChange(dateStr);
		}
	};

	const handleDateChange = (date: Date) => {
		setDateTimeObject(date);
	};

	React.useEffect(() => {
		if (dateTimeString) {
			const currentDate = parseDate(dateTimeString);
			setDateTimeObject(currentDate);
		}
	}, [dateTimeString]);

	React.useEffect(() => {
		if (dateTimeObject) {
			returnDateTime(dateTimeObject);
		} else {
			//pass back the null value
			if (onChange) {
				onChange('');
			}
		}
	}, [dateTimeObject]);

	return (
		<div className="row form-row">
			<div className="col-12">
				<div className={disabled ? 'form-control date-picker disabled' : 'form-control date-picker'}>
					<CalendarIcon />
					<DatePicker
						dateFormat="dd/MM/yyyy"
						selected={dateTimeObject}
						onChange={(date: Date) => handleDateChange(date)}
						placeholderText="DD/MM/YYYY"
						className={`form-control ${className}`}
						showMonthDropdown={showDropdowns}
						showYearDropdown={showDropdowns}
						dropdownMode="select"
						maxDate={excludeFuture ? (minAge ? new Date(parseDate(maxDate)) : new Date()) : null}
						minDate={excludePast ? new Date() : null}
						disabled={disabled}
					/>
				</div>
			</div>
		</div>
	);
};

export default DateInput;
